jQuery(document).ready(function($) {

  /*
  * jQuery throttle / debounce - v1.1 - 3/7/2010
  * http://benalman.com/projects/jquery-throttle-debounce-plugin/
  * 
  * Copyright (c) 2010 "Cowboy" Ben Alman
  * Dual licensed under the MIT and GPL licenses.
  * http://benalman.com/about/license/
  */
  function st_throttle(e,f,j,i){var c=undefined;var h,d=0;if(typeof f!=="boolean"){i=j;j=f;f=c}function g(){var o=this,m=+new Date()-d,n=arguments;function l(){d=+new Date();j.apply(o,n)}function k(){h=c}if(i&&!h){l()}h&&clearTimeout(h);if(i===c&&m>e){l()}else{if(f!==true){h=setTimeout(i?k:l,i===c?e-m:e)}}}if($.guid){g.guid=j.guid=j.guid||$.guid++}return g}

  /*
  $(window).on('scroll', st_throttle(500, function() {
    console.log('do something');
  }));
  */

  /* SIDEBAR NAVIGATION ----------------------------------------- */
  $('.sidebar-menu-container').each(function() {

    var $navigation = $(this);

    // Handle no-link menu items
    $('.sidebar-menu > ul.menu', $navigation).each(function() {

      // Create variable for the main navigation menu
      var $menu = $(this);

      // Handle items with no-link
      $('li.no-link', $menu).each(function() {

        // Create variable to contain the text of the item
        var element_text = $('> a', this).text();

        $('> a', this).detach();
        $(this).removeClass('no-link').prepend('<span class="no-link">'+element_text+'</span>');

      });

    });

  });

  $('.multi-slider-block').each(function() {

    // The following gobdf_slider_modal function allows you to set heights of the modal window upon modal window opening
    function gobdf_slider_modal() {
      var container_height = $('.modaal-wrapper .modaal-container').height();
      var content_height = container_height;
  
      $('.modaal-wrapper .modaal-container .slider-modal-info').css({
        'height': container_height+'px'
      });
    }
  
    function initialize_modal_windows($slider) {
      $('a.wrap.modal', $slider).modaal({
        custom_class: 'multi-slider-modal-window',
        background: '#fff',
        overlay_opacity: 0.5,
        width: 1200
        // after_open: gobdf_slider_modal
      });
    }

    var $container = $(this);
    var $slider_container = $('.multi-slider', $container);
    var $slider = $('.slider > .wrap', $slider_container);
    var slide_count = $('.item', $slider).length;
    var $slider_nav = $('.slider-nav', $container);
    var $nav_prev = $('.slider--prev', $slider_nav);
    var $nav_next = $('.slider--next', $slider_nav);
    var autoplay = ( $container.hasClass('autoplay-slider') ? true : false );
    var autoplay_speed = ( autoplay ? $container.data('autoplay-speed') : 4000 );
    
    $nav_prev.each(function() {
      $(this).on('click', function() {
        $slider.slick('slickPrev');
      });
    });
    
    $nav_next.each(function() {
      $(this).on('click', function() {
        $slider.slick('slickNext');
      });
    });
    
    $slider.on('init reInit breakpoint', function(slick) {
      
      $slider_container.addClass('show');
      var active_slides = $('.slick-active', $slider).length;

      if (active_slides < slide_count) {
        $slider_nav.addClass('show');
      } else {
        $slider_nav.removeClass('show');
      }

      if($container.hasClass('modal')) {
        initialize_modal_windows($slider);
      }
     
    });

    var slider_args = {
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1921,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1441,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 961,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 481,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    };

    if (autoplay) {
      slider_args['autoplay'] = true;
      slider_args['autoplaySpeed'] = autoplay_speed;
    }

    $slider.slick(slider_args);

  });

  /* POSTS GRID ------------------------------------------------- */
  $('.posts-grid').each(function() {

    // Declare main variables
    var $container = $(this);
    var $pgis = $('.posts-grid-item', $container);

    // Function will set all slides to the same height
    function set_pgi_height() {

      // Set the minimum height variable
      var pgi_min_height = 0;

      // Reset the min-height of all slides
      $('.posts-grid-item > .wrap', $container).css({
        'min-height': pgi_min_height+'px'
      });

      // Iterate over each post grid item
      $pgis.each(function() {

        // Declare variable for this item
        var $pgi = $(this);

        // Set the minimum height variable to this slide's height if it's the tallest one so far
        if ($('> .wrap', $pgi).outerHeight() > pgi_min_height) {
          pgi_min_height = $('> .wrap', $pgi).outerHeight();
        }

      });

      // Set all post grid items to the minimum height variable
      $('.posts-grid-item > .wrap', $container).css({
        'min-height': pgi_min_height+'px'
      });

    }

    // Call the set height function
    set_pgi_height();

    // Call the set height function whenever the window is resized
    $(window).on('resize', st_throttle(1000, function() {
      set_pgi_height();
    }));

    // Handle the slider variations
    if ($container.hasClass('slider-variation')) {

      // Declare the relevant variables
      var $slider = $('.posts-grid-container', $container);
      var slides_to_show = $slider.data('sts');

      // Call the set height function upon initiation of the slider
      $slider.on('init reInit', function(slick) {  
        set_pgi_height();  
      });
  
      // Create initial slider arguments variable
      var slick_args = {
        'dots': true,
        'arrows': false,
        'slidesToShow': slides_to_show,
        'slidesToScroll': 1,
        'responsive': [
          {
            'breakpoint': 601,
            'settings': {
              'slidesToShow': 1
            }
          }
        ]
      };
  
      // Add responsive breakpoint for 4 column sliders
      if (slides_to_show > 3) {
        slick_args.responsive.push({
          'breakpoint': 1801,
          'settings': {
            'slidesToShow': 3
          }
        });
      }

      // Add responsive breakpoint for 3 column sliders
      if (slides_to_show > 2) {
        slick_args.responsive.push({
          'breakpoint': 1101,
          'settings': {
            'slidesToShow': 2
          }
        });
      }
      
      // Initialize the slider
      $slider.slick(slick_args);

    }

  });

  /* POSTS SLIDERS ---------------------------------------------- */
  $('.posts-slider').each(function() {

    var $slider = $('.posts-wrap', this);

    // Create function to handle dynamically setting slide height to tallest slide
    function set_posts_slide_height() {

      // Set tallest height variable
      var tallest_slide_height = 0;

      // Cycle through each slide, determining the min-height
      $('.item > .wrap', $slider).each(function() {

        // Reset the min-height of the slide to get an accurate this_height
        $(this).css({
          'min-height': ''
        });
        
        // Set variable for current slide height
        var this_height = $(this).innerHeight();

        // Set height of tallest height variable if necessary
        if (this_height > tallest_slide_height) {          
          tallest_slide_height = this_height;
        }

      });

      // Set heights of all slides
      $('.slick-slide .item > .wrap', $slider).css({
        'min-height': tallest_slide_height+'px'
      });

    }    

    // Set slide heights on slider init/reinit/breakpoint
    $slider.on('init reInit breakpoint', function(slick) {
      set_posts_slide_height();
    });

    // Throttle resizing of slides on window ressize
    $(window).on('resize', st_throttle(500, function() {
      set_posts_slide_height();
    }));

    $slider.slick({
      'dots': true,
      'arrows': false,
      'fade': true,
      'slidesToShow': 1,
      'slidesToScroll': 1,
      'autoplay': false,
      'autoplaySpeed': 5000
    });

  });


  /* STATISTICS SLIDERS ----------------------------------------- */
  $('.statistics-slider').each(function() { 

    // Set variable for slider
    var $slider = $('> .wrap', this);

    // Create function to handle dynamically setting slide height to tallest slide
    function set_statistic_slide_height() {

      // Set tallest height variable
      var tallest_slide_height = 0;

      // Cycle through each slide, determining the min-height
      $('.item', $slider).each(function() {

        // Reser the min-height to get an accurate this_height
        $(this).css({
          'min-height': ''
        });
        
        // Set variable for current slide height
        var this_height = $(this).innerHeight();

        // Set height of tallest height variable if necessary
        if (this_height > tallest_slide_height) {          
          tallest_slide_height = this_height;
        }

      });

      // Set heights of all slides
      $('.slick-slide .item', $slider).css({
        'min-height': tallest_slide_height+'px'
      });

    }    

    // Set slide heights on slider init/reinit/breakpoint
    $slider.on('init reInit breakpoint', function(slick) {
      set_statistic_slide_height();
    });

    // Throttle resizing of slides on window ressize
    $(window).on('resize', st_throttle(500, function() {
      set_statistic_slide_height();
    }));
    
    // Initialize slider
    $slider.slick({
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow: `<button class="svg-icon slider-arrow arrow-left slick-prev">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43.18 40.22" role="img" aria-label="Arrow Left Icon">
      <title>Arrow Left Icon</title>
      <line class="path" x1="43.18" y1="20.14" x2="6.47" y2="20.14"/>
      <polyline class="path" points="21.6 2.52 4.79 18.49 21.49 37.96"/>
      </svg>
      </button>`,
      nextArrow: `<button class="svg-icon slider-arrow arrow-right slick-next">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43.18 40.22" role="img" aria-label="Arrow Right Icon">
      <title>Arrow Right Icon</title>
      <line class="path" x1="0" y1="20.14" x2="36.72" y2="20.14"/>
      <polyline class="path" points="21.59 2.52 38.4 18.49 21.7 37.96"/>
      </svg>
      </button>`, 
      responsive: [
        {
          breakpoint: 1921,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1441,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1001,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 701,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });

  });

  /* SLIDESHOW BLOCK -------------------------------------------- */
  $('.slideshow-block').each(function() {

    $(this).slick({
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      dots: false,
      fade: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1000,
      useAutoplayToggleButton: false
    });

  });


  /* TIMELINE SLIDER BLOCK -------------------------------------- */
  $('.timeline-slider-block').each(function() {

    function reset_items($item) {
      $('.item', $slider).removeClass('active');
    }
  
    function initialize_modal_windows($slider) {

      $('.item.clickable', $slider).each(function() {

        var $item = $(this);

        $('a.item-content.modal', $item).modaal({
          custom_class: 'timeline-slider-modal-window',
          background: '#000',
          overlay_opacity: 0.5,
          width: 1475,
          after_open: function(e) {
            reset_items();
          }
          // after_open: gobdf_slider_modal
        });
        
        $item.on('click', function() {
          $item.toggleClass('active');
        });

      });
      
    }

    var $container = $(this);
    var $slider_container = $('.timeline-slider', $container);
    var $slider = $('.slider > .wrap', $slider_container);
    var slide_count = $('.item', $slider).length;
    var $slider_nav = $('.slider-nav', $container);
    var $progress_bar = $('.slider-progress .progress-bar', $slider_nav);
    var $nav_prev = $('.slider--prev', $slider_nav);
    var $nav_next = $('.slider--next', $slider_nav);
    var autoplay = ( $container.hasClass('autoplay-slider') ? true : false );
    var autoplay_speed = ( autoplay ? $container.data('autoplay-speed') : 4000 );
    
    $nav_prev.each(function() {
      $(this).on('click', function() {
        $slider.slick('slickPrev');
      });
    });
    
    $nav_next.each(function() {
      $(this).on('click', function() {
        $slider.slick('slickNext');
      });
    });
    
    $slider.on('afterChange', function(event, slick, currentSlide, nextSlide) {
      
      var step = 100 / (slide_count - 1);
      var percentage = currentSlide * step;
      // console.log(percentage);
      $progress_bar.css({
        'width': percentage+'%'
      });
    
    });
    
    $slider.on('init reInit breakpoint', function(slick) {
      
      $slider_container.addClass('show');
      var active_slides = $('.slick-active', $slider).length;

      if (active_slides < slide_count) {
        $slider_nav.addClass('show');
      } else {
        $slider_nav.removeClass('show');
      }

      initialize_modal_windows($slider);
     
    });

    var slider_args = {
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1921,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1441,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 961,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 481,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    };

    if (autoplay) {
      slider_args['autoplay'] = true;
      slider_args['autoplaySpeed'] = autoplay_speed;
    }

    $slider.slick(slider_args);

  });

});